<template>
    <div>
        <div v-if="getemail">
            <v-card class="fill-height" elevation="0">
                <v-card-subtitle style="text-align:right;"><i>Email Receipt Last updated: {{ lastupdateddate }}</i></v-card-subtitle>
                <v-card-text>
                    <v-row>
                        <v-col cols="1">
                            <v-subheader>
                                Subject
                            </v-subheader>
                        </v-col>
                        <v-col cols="11">
                            <v-text-field
                                v-model="subject"
                                outlined
                                dense
                                @keydown="validateForm"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="1">
                            <v-subheader>
                                Content
                            </v-subheader>
                        </v-col>
                        <v-col cols="11">
                            <span style="float: right;">
                                <v-tooltip bottom color="#000C66">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="#000C66" dark v-bind="attrs" v-on="on" outlined x-small>
                                            <v-icon>mdi-autorenew</v-icon>&nbsp;Keywords
                                        </v-btn>
                                    </template>
                                    <span>
                                        %%applicantName%% - Applicant's firstname<br />
                                        %%applicantSurname%% - Applicant's lastname<br />
                                        %%courses%% - Course list that the applicant has applied to<br />

                                    </span>
                                </v-tooltip>
                            </span><br />
                            <v-textarea
                                outlined
                                v-model="content"
                                dense
                                @keydown="validateForm"
                                auto-grow
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="!btnSubmitEnable"
                        color="#80CBC4"
                        type="submit"
                        :loading="uploadloading"
                        @click="saveEmailTemplate"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
        <div v-else>
            <v-row 
                class="fill-height"
                align-content="center"
                justify="center"
            >
                <v-container style="height: 400px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                        >
                            Calling saved template...
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear
                                color="#80CBC4"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
        </div>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            getemail: false,
            subject: "",
            content: "",
            lastupdateddate: "",
            uploadloading: false,
            btnSubmitEnable: false
        }
    },
    methods: {
        initialize(){
            const that = this;
            
            that.subject = "CUPE Application Confirmation";
            that.content = "Hello <candidate name>, \n\n"+
                            "Thank you for your interest in a part time instructor position at King's University College! "+
                            "This email will confirm that we have received your application for the <year-year> Academic Year for the following course(s): \n\n"+
                            "<course #1> \n"+"<course #2 etc...> \n" + 
                            "\n Please review your selections to confirm they are correct. If there are errors in your selections, please contact HR at HR@kings.uwo.ca for assistance. \n\n"+
                            "Your interest in this opportunity is appreciated. Only those applicants selected to move forward in the recruitment process will be contacted. \n\n"+
                            "Thank you again for taking the time to apply. If you have any questions with regards to your application, please contact HR@kings.uwo.ca. \n\n"+
                            "Best regards, \nHuman Resources, King's University College";
        },
        getEmailTemplate(){
            const that = this;
            that.getemail = false;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getemail';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (result) {
                    if(!result.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+result.message+" - now showing default contents", "#EF6C00"); //orange
                        that.initialize();
                    }else {
                        if(JSON.stringify(result.data) == "{}"){
                            that.initialize();
                        }else {
                            var date = new Date();
                            if(result["data"].hasOwnProperty("updatedTimestamp")){
                                date = new Date(parseFloat(result["data"]["updatedTimestamp"]));
                            }else {
                                date = new Date(parseFloat(result["data"]["createdTimestamp"]));
                            }
                            that.lastupdateddate = date.toDateString()+", "+String(date.getHours()).padStart(2, '0')+":"+String(date.getMinutes()).padStart(2, '0')+":"+String(date.getSeconds()).padStart(2, '0');
                            that.subject = result.data.config.subject;
                            that.content = result.data.config.content;
                        }
                    }

                    that.getemail = true;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        validateForm(){
            const that = this;

            if(that.subject.length > 0 && that.content.length > 0){
                that.btnSubmitEnable = true;
            }else {
                that.btnSubmitEnable = false;
            }
        },
        saveEmailTemplate(){
            const that = this;

            that.uploadloading = true;
            
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
            let email = {
                subject : that.subject,
                content: that.content
            };

            const formData = new FormData();

            formData.append("mode", "setemail");
            formData.append("data", JSON.stringify(email));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Email Receipt template Saved!", "#388E3C"); //green
                    }

                    that.uploadloading = false;
                })
                .catch(function(err){
                    that.uploadloading = false;
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling

            that.btnSubmitEnable = false;
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    }, 
    created(){
        const that = this;
        that.getEmailTemplate();
    }
}
</script>